// TASK: modify search box, display properties as default, it means no areas

import $ from "./jquery";

$(function () {
  $(".js-estl-searchbox").each(function () {
    const $searchbox = $(this);

    $searchbox.on("estl:searchbox:init", function (ev, obj) {
      // -- set properties
      const data = obj.getData();

      const properties = [];

      data.forEach((d) => {
        if (d.areas) {
          d.areas.forEach((area) => {
            if (area.properties) {
              area.properties.forEach((property) => {
                properties.push(property);
              });
            }
          });
        }
      });

      obj.setProperties(properties);

      // render properties
      obj.renderMoreProperties();
    });
  });
});
